import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Loader, Table, Checkbox} from 'semantic-ui-react';
import {map, includes} from 'lodash';
import {Actions} from '../../common/actions';

class PendingItemsTable extends Component {
  constructor(props) {
    super(props);
    this.isRowMarked = this.isRowMarked.bind(this);
    this.onSequenceHeaderCheckboxChange = this.onSequenceHeaderCheckboxChange.bind(this);
    this.onSequenceItemCheckboxChange = this.onSequenceItemCheckboxChange.bind(this);
  }

  isRowMarked(sequence) {
    const {sequencesMarked} = this.props;
    return includes(sequencesMarked, sequence);
  }

  onSequenceHeaderCheckboxChange(event, value) {
    const {pendingItems} = this.props;

    this.props.isMarkedAllItems(value.checked);

    if (value.checked) {
      this.props.changeSequencesMarked(
        map(pendingItems, 'orderSequence')
      );
      return;
    }
    this.props.changeSequencesMarked([]);
  }

  onSequenceItemCheckboxChange(checked, value) {
    const {sequencesMarked} = this.props;
    const newSequences = [...sequencesMarked];

    const index = newSequences.indexOf(value);
    if (checked) {
      if (index === -1) {
        newSequences.push(value);
        this.props.changeSequencesMarked(newSequences);
      }
      return;
    }

    if (index !== -1) {
      newSequences.splice(index, 1);
      this.props.changeSequencesMarked(newSequences);
    }
  }

  renderCheckboxHeader() {
    const {pendingItems, loading, isMarkAllItems} = this.props;
    if (!pendingItems.length) {
      return;
    }
    return (
      <Table.HeaderCell>
        <Checkbox
          onChange={this.onSequenceHeaderCheckboxChange}
          disabled={loading}
          checked={isMarkAllItems}
        />
      </Table.HeaderCell>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <Table striped>
          <Table.Header>
            <Table.Row textAlign='center'>
              {this.renderCheckboxHeader()}
              <Table.HeaderCell>Secuencia</Table.HeaderCell>
              <Table.HeaderCell>Código</Table.HeaderCell>
              <Table.HeaderCell>Descripción</Table.HeaderCell>
              <Table.HeaderCell>Cantidad</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {this.renderTableBody()}
        </Table>
      </Card>
    );
  }

  renderTableBody() {
    const {loading, processingInvoice} = this.props;

    if (loading || processingInvoice) {
      return (
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      );
    }

    return (
      <Table.Body>
        {this.renderPendingItems()}
      </Table.Body>
    );
  }

  renderPendingItems() {
    const {pendingItems} = this.props;

    if (!pendingItems.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='4'>No hay items pendientes</Table.Cell>
        </Table.Row>
      );
    }

    return pendingItems.map((element, index) => {
      return (
        <Table.Row key={index} textAlign='center'>
          <Table.Cell>
            <Checkbox
              id={`chassis-checkbox-${index}`}
              checked={this.isRowMarked(element.orderSequence)}
              onChange={(e, {checked}) => this.onSequenceItemCheckboxChange(checked, element.orderSequence)}
            />
          </Table.Cell>
          <Table.Cell>{element.orderSequence}</Table.Cell>
          <Table.Cell>{element.partCode}</Table.Cell>
          <Table.Cell>{element.partName}</Table.Cell>
          <Table.Cell>{element.pendingQuantity}</Table.Cell>
        </Table.Row>
      );
    });
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.lubricantsInvoicing.loadingPendingItemsList,
    'pendingItems': state.lubricantsInvoicing.pendingItemsList,
    'isMarkAllItems': state.lubricantsInvoicing.markAllItems,
    'sequencesMarked': state.lubricantsInvoicing.sequencesMarked,
    'processingInvoice': state.lubricantsInvoicing.creatingInvoice,
  };
};

const {
  isMarkedAllItems,
  changeSequencesMarked,
} = Actions;

export default connect(mapStateToProps, {
  isMarkedAllItems,
  changeSequencesMarked,
})(PendingItemsTable);
